import React from "react";
import { Layout } from "@components";
import NewsPage from "@page-contents/news";

export default props => (
	<Layout {...props} meta={{ title: "Новости" }}>
		<NewsPage />
	</Layout>
);
